/**
 * Right-side chat panel — collapsed by default, pushes the layout when
 * opened (not an overlay). Open/closed state persists in localStorage.
 *
 * Layout strategy: a single boolean toggles whether App.tsx renders the
 * third resizable Panel. When the panel is removed, react-resizable-panels
 * auto-expands the remaining panels.
 */
import { useEffect, useState } from "react";
import { Button } from "@cloudscape-design/components";

const STORAGE_KEY = "soc1lab-v3-chat-open";

function getInitialOpen(): boolean {
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export function useChatDrawer() {
  const [open, setOpen] = useState<boolean>(() => getInitialOpen());

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, open ? "1" : "0");
  }, [open]);

  return { open, toggle: () => setOpen((o) => !o), close: () => setOpen(false) };
}

export function ChatDrawerToggle({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  return (
    <Button
      onClick={onToggle}
      iconName={open ? "close" : "gen-ai"}
      variant="primary"
      ariaLabel={open ? "Close chat" : "Open chat"}
    >
      {open ? "Close chat" : "Chat"}
    </Button>
  );
}
